import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from '../../../setup/index'
import media from '../../../common/MediaQueries'

const PresenterStyled = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  @media ${media.tablet} {
    flex-direction: row;
    align-items: center;
    padding: 0 50px 180px;
  }
`

const PresenterMediaStyled = styled.div`
  margin-bottom: 100px;
  margin-right: 2rem;
  z-index: 2;
  @media ${media.tablet} {
    width: 30.125rem;
    margin: 0;
  }
`

const PresenterMediaBgStyled = styled.div<WithTheme>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.blue3};

  @media ${media.tablet} {
    width: 28.125rem;
    height: 26.25rem;
  }
`

const PresenterMediaImageStyled = styled.div`
  position: relative;
  display: flex;
  top: 2rem;
  left: 2rem;
  width: 100%;
  height: 100%;

  .gatsby-image-wrapper {
    width: 100% !important;
    height: 100% !important;
  }

  > div {
    width: 100%;
  }
`

const PresenterContentStyled = styled.div`
  width: 100%;
  @media ${media.tablet} {
    width: calc(100% - 30.125rem);
    margin-left: 6.75rem;
    margin-top: 2rem;
    max-width: 32.5rem;
  }
`

const PresenterContentNameStyled = styled(Text)<WithTheme>`
  display: block;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin-bottom: 2rem;
`

const PresenterContentDescStyled = styled.div`
  * {
    font-size: 0.9375rem;
    line-height: 1.6;

    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }

    @media ${media.tablet} {
      font-size: 1.125rem;
      line-height: 1.7;
    }
  }
`

const PresenterBackgroundImageStyled = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: none;
  @media ${media.tablet} {
    display: block;
  }
`

export {
  PresenterStyled,
  PresenterMediaStyled,
  PresenterMediaBgStyled,
  PresenterMediaImageStyled,
  PresenterContentStyled,
  PresenterContentNameStyled,
  PresenterContentDescStyled,
  PresenterBackgroundImageStyled
}
